import { UnitValue } from '../../data-structures/unit-value.model';

export interface FeedstockAutofillPackageInterface {
  characteristicsPkg: CharacteristicsAutofillPackage;
  bmpPkg: BmpAutofillPackage;
}

export class FeedstockAutofillPackage {
  characteristicsPkg: CharacteristicsAutofillPackage;
  bmpPkg: BmpAutofillPackage;

  constructor(param: FeedstockAutofillPackageInterface = {
    characteristicsPkg: new CharacteristicsAutofillPackage(),
    bmpPkg: new BmpAutofillPackage()
  }) {
    this.characteristicsPkg = new CharacteristicsAutofillPackage(param.characteristicsPkg);
    this.bmpPkg = new BmpAutofillPackage(param.bmpPkg);
  }
}

export interface CharacteristicsAutofillPackageInterface {
  ts: UnitValue;
  vs: UnitValue;
}

export class CharacteristicsAutofillPackage {
  ts: UnitValue;
  vs: UnitValue;

  constructor(param: CharacteristicsAutofillPackageInterface = {
    ts: new UnitValue(),
    vs: new UnitValue()
  }) {
    this.ts = new UnitValue(param.ts);
    this.vs = new UnitValue(param.vs);
  }
}

export interface BmpAutofillPackageInterface {
  bmp: UnitValue;
  ch4Concentration: UnitValue;
  period: UnitValue;
}

export class BmpAutofillPackage {
  bmp: UnitValue;
  ch4Concentration: UnitValue;
  period: UnitValue;

  constructor(param: BmpAutofillPackageInterface = {
    bmp: new UnitValue(),
    ch4Concentration: new UnitValue(),
    period: new UnitValue()
  }) {
    this.bmp = new UnitValue(param.bmp);
    this.ch4Concentration = new UnitValue(param.ch4Concentration);
    this.period = new UnitValue(param.period);
  }
}
